import { EmployeePlanDetailResponse } from '@/types/service-response'

export class EmployeePlanDetail {
  private constructor (
    readonly addressId: number,
    readonly isReplacement: boolean,
    readonly addressNumber: string,
    readonly addressName: string,
    readonly addressColor: string,
    readonly colorCode: string,
    readonly colorDescription: string,
    readonly note: string,
    readonly employeeId: number
  ) {}

  public static createFromResponse (data: EmployeePlanDetailResponse[], employeeId: number): EmployeePlanDetail[] {
    return data.map((item: EmployeePlanDetailResponse) => {
      return new EmployeePlanDetail(
        item.AdressId,
        item.STV === 1,
        item.AdressNummer ? item.AdressNummer : '',
        item.Adressname ? item.Adressname : '',
        item.Farbe ? item.Farbe : '',
        item.ColorCode ? item.ColorCode : '',
        item.ColorName ? item.ColorName : '',
        item.Bemerkung ? item.Bemerkung : '',
        employeeId
      )
    })
  }
}
